"use strict";

var _interopRequireWildcard = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/core-js/modules/es.array.iterator.js");
require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/core-js/modules/es.promise.js");
require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/core-js/modules/es.object.assign.js");
require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/core-js/modules/es.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _App = _interopRequireDefault(require("@/App.vue"));
var _router = _interopRequireDefault(require("@/router"));
var _store = _interopRequireDefault(require("@/store"));
require("@/permission");
require("@/styles/index.scss");
var _vant = _interopRequireDefault(require("vant"));
require("vant/lib/index.less");
var _bus = _interopRequireDefault(require("@/utils/bus"));
var _elementUi = _interopRequireDefault(require("element-ui"));
require("element-ui/lib/theme-chalk/index.css");
require("amfe-flexible");
var echarts = _interopRequireWildcard(require("echarts"));
var moment = _interopRequireWildcard(require("moment"));
_vue.default.use(_vant.default).use(_bus.default);
_vue.default.use(_elementUi.default, {
  size: 'small',
  zIndex: 3000
});
_vue.default.prototype.$echarts = echarts;
_vue.default.prototype.$moment = moment;
_vue.default.config.productionTip = false;
new _vue.default({
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
}).$mount('#app');